import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyDonut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 240 203"
    {...props}
  >
    <path
      fill="var(--dataviz-color-sequential-blue-scale04)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M51.902 69.668a78.15 78.15 0 0 0 79.693 109.622l-3.712-34.5a43.45 43.45 0 0 1-44.31-60.95z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale01)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M126.974 179.662a78.15 78.15 0 0 0 63.325-118.196l-29.772 17.82a43.455 43.455 0 0 1-14.079 59.052 43.45 43.45 0 0 1-21.13 6.665z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale02)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M196.42 74.13a78.16 78.16 0 0 0-50.497-47.338 78.15 78.15 0 0 0-68.283 11.33l20.251 28.175a43.452 43.452 0 0 1 66.041 20.02z"
    />
    <path
      fill="var(--dataviz-color-sequential-blue-scale03)"
      stroke="var(--dataviz-color-sequential-blue-scale05)"
      strokeDasharray="6 6"
      strokeWidth={2}
      d="M80.831 35.948a78.15 78.15 0 0 0-30.207 36.805l32.252 12.796a43.45 43.45 0 0 1 16.796-20.464z"
    />
  </svg>
);
export default SvgEmptyDonut;
